import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "A method for estimating the Thiele and Small parameters of an electrodynamic loudspeaker is presented below. Navigate with the arrows to discover it!",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 4,
      rows: 3,
      colsSize: [1, 3, 3, 1],
      rowsSize: [1, 2, 2],
      colSpan: {
        "0:0": 4,
      },
      rowSpan: {
        "1:2": 2,
      },
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Measurement of the dc resistance",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/19/principle/slide-1.png`,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "<ol><li>Using an accurate multimeter, measure the DC resistance of the the driver<li>Here, we find: <span style='font-weight:700'>R<sub>e</sub> = 3.85 Ω</span><li>Also, check the value of the probe resistance that will be used to measure the electrical impedance</ol>",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: 400,
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Tested driver:</br><span style='font-weight:700'>10” Peerless subwoofer</span>",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: 400,
                    textAlign: "center",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
